import cn from 'classnames'
import { FC, useCallback, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Loader } from 'core-components/library/loader'

import { TRANSLATION_KEYS } from '../../translations'

import styles from './AddInitiativeCard.module.scss'

interface IAddInitiativeCardProps {
  isLoading: boolean
  initiativesCount: number
  onClick: () => void
}

export const AddInitiativeCard: FC<IAddInitiativeCardProps> = ({
  onClick,
  initiativesCount,
  isLoading,
}) => {
  /* ------------------ Constants ------------------ */
  const isAddInitiativesEnabled = useMemo(() => {
    return !isLoading && initiativesCount > 0
  }, [initiativesCount, isLoading])

  /* ------------------ Methods ------------------ */
  const handleClick = useCallback(() => {
    if (!isAddInitiativesEnabled) {
      return
    }

    onClick()
  }, [onClick, isAddInitiativesEnabled])

  return (
    <div
      className={cn(styles.root, {
        [styles.isDisabled]: !isAddInitiativesEnabled,
      })}
      onClick={handleClick}
    >
      <div className={styles.content}>
        {!isLoading && (
          <>
            <div className={styles.crossIcon}>+</div>
            <div className={styles.message}>
              <Translation
                text={TRANSLATION_KEYS.addInitiativeButton}
                replaceParams={[
                  {
                    value: initiativesCount.toString(),
                    key: '{initiativesCount}',
                  },
                ]}
              />
            </div>
          </>
        )}
        {isLoading && <Loader />}
      </div>
    </div>
  )
}
